module.exports = __webpack_public_path__ + "media/assets/images/btn_analysis-9605b55919c8df41d9356552dfef8120.png";